import * as React from "react";
import { Collapse } from "react-bootstrap";
import { SvgSprite } from "./SvgSprite";

interface FooterProps {
  copyright: string;
  featuredCategories?: React.ReactNode;
  hiddenCategories?: React.ReactNode;
  featuredCities?: React.ReactNode;
  socialMedia: React.ReactNode;
  volunteersSection: React.ReactNode;
  organisationsSection: React.ReactNode;
  legalSection: React.ReactNode;
  acknowledgementOfCountry?: React.ReactNode;
  showQuickSearch?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  copyright,
  featuredCategories,
  hiddenCategories,
  featuredCities,
  socialMedia,
  volunteersSection,
  organisationsSection,
  legalSection,
  acknowledgementOfCountry,
  showQuickSearch = true,
}) => {
  const [categoriesExpanded, setCategoriesExpanded] = React.useState(false);

  const toggleExpandCategories = React.useCallback((e): void => {
    e.preventDefault();
    setCategoriesExpanded((state) => !state);
  }, []);

  return (
    <footer className="global-footer">
      <div className="container pt-5 pb-4">
        {/* Quick Search */}
        {showQuickSearch === true && (
          <section className="d-none d-md-block">
            <h2 className="footer-heading">Quick Search</h2>
            <ul className="footer__quick-search mb-3">
              {typeof hiddenCategories !== "undefined" &&
                typeof featuredCategories !== "undefined" && (
                  <li className="footer__quick-search-category">
                    <h3 className="footer__quick-search-title">Categories</h3>
                    <ul className="footer__list-horizontal">
                      {featuredCategories}
                      <li>
                        <button
                          css={`
                            background: none;
                            border: 0;
                            color: #2765cf;
                            line-height: 1.5;

                            &:hover {
                              text-decoration: underline;
                            }
                          `}
                          type="button"
                          className="p-0"
                          aria-label="View all toggler"
                          aria-expanded={categoriesExpanded ? "true" : "false"}
                          onClick={toggleExpandCategories}
                        >
                          View all
                          <SvgSprite
                            id="icons:chev-down"
                            width={12}
                            height={12}
                            css={`
                              margin-left: 0.25rem;
                              transition: transform 0.3s
                                ${(p): string => p.theme.timingFnEaseOut};
                            `}
                            style={{
                              transform: categoriesExpanded
                                ? "rotate3d(1,0,0,180deg)"
                                : "rotate3d(0,0,0,0deg)",
                            }}
                          />
                        </button>
                      </li>
                    </ul>
                    {/* View all categories */}
                    <Collapse
                      in={categoriesExpanded}
                      css={`
                        &.collapse.show .column-list {
                          opacity: 1;
                          transform: translate3d(0, 0, 0);
                        }

                        &.collapsing .column-list {
                          opacity: 0;
                          transform: translate3d(0, -10px, 0);
                        }

                        &.collapse .column-list {
                          opacity: 0;
                          transform: translate3d(0, -10px, 0);
                        }
                      `}
                    >
                      <div>
                        <ul
                          className="column-list mb-4"
                          css={`
                            transition: all 0.3s
                              ${(p): string => p.theme.timingFnEaseOut};
                          `}
                        >
                          {hiddenCategories}
                        </ul>
                      </div>
                    </Collapse>
                  </li>
                )}
              {typeof featuredCities !== "undefined" && (
                <li className="footer__quick-search-category">
                  <h3 className="footer__quick-search-title">Major Cities</h3>
                  <ul className="footer__list-horizontal">{featuredCities}</ul>
                </li>
              )}
            </ul>
          </section>
        )}
        <div className="row">
          <div className="col-lg-10">
            <div className="row">
              <div className="col-md-4">
                <section>
                  <h2 className="footer-heading">SEEK Volunteer</h2>
                  <ul className="footer__list-vertical">{volunteersSection}</ul>
                </section>
              </div>
              <div className="col-md-4">
                <section>
                  <h2 className="footer-heading">Organisations</h2>
                  <ul className="footer__list-vertical">
                    {organisationsSection}
                  </ul>
                </section>
              </div>
              <div className="col-md-4">
                <section>
                  <h2 className="footer-heading">Social Media</h2>
                  <ul className="footer__list-vertical">{socialMedia}</ul>
                </section>
              </div>
            </div>
          </div>
        </div>

        {acknowledgementOfCountry}

        <div className="row">
          <div className="col-md-4 col-lg-9">
            <section>
              <ul className="footer__list-vertical footer__list-lg-horizontal">
                {legalSection}
              </ul>
            </section>
          </div>

          <div className="col-lg-3">&copy; {copyright}</div>
        </div>
      </div>
    </footer>
  );
};
